import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LearningStandards from "./routes/LearningStandards";
import SubjectGroupsAndSubjects from "./routes/SubjectGroupsAndSubjects";
import MYPRelatedConcepts from "./routes/MYPRelatedConcepts";
import AssessmentCriteria from "AssessmentCriteria";
import MYPKeyConcepts from "./routes/MYPKeyConcepts";
import EvaluationCriteria from "EvaluationCriteria";
import LocalGrades from "./routes/LocalGrades";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";
import RoutineAndMealTemplates from "Administrator/commonComponents/RoutineAndMealTemplates";
import AssessmentToolSetup from "AssessmentToolSetup";
import LearnerProfileAttributes from "Administrator/commonComponents/LearnerProfileAttributes";
import Atls from "Administrator/commonComponents/Atls";
import ScoreCategories from "./routes/ScoreCategories";
import Continuum from "Continuum";
import GradingPeriods from "Administrator/commonComponents/GradingPeriods";
import GradingPeriodsV3 from "Administrator/commonComponents/GradingPeriodsV3";
import GradingSetup from "Administrator/commonComponents/GradingSetup";
import GradingSetupV2 from "Administrator/commonComponents/GradingSetupV2";
import AssessmentSettingsEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria";
import GpaAndCredits from "Administrator/commonComponents/GpaAndCredits";
import { updateChildRoutes } from "Administrator/modules/AdministratorModule";
import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import WorkbookTemplates from "../../commonComponents/WorkbookTemplates";
import ProjectProgressIndicators from "../../commonComponents/ProjectProgressIndicators";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import Datasets from "Datasets";

export default store => ({
  path: "mypAcademicSetup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const { routes } = nextState;
    const pathname = _.get(nextState, "location.pathname");
    if (_.includes(pathname, "/evaluationCriteria")) {
      const updatedPathname = _.replace(
        pathname,
        "/evaluationCriteria",
        "/evaluation-criteria"
      );
      return replace(updatedPathname);
    }
    store.dispatch(
      updateChildRoutes({
        routes,
        path: "mypAcademicSetup",
        pathId: "MYP_ACADEMIC_SETUP",
        type: "replace",
      })
    );
  },
  childRoutes: [
    SubjectGroupsAndSubjects(store),
    LearningStandards(store),
    SubjectStandardsV2(store),
    Datasets(store),
    MYPKeyConcepts(store),
    LearnerProfileAttributes(store),
    Atls(store),
    MYPRelatedConcepts(store),
    EvaluationCriteria(store),
    AssessmentCriteria(store),
    LocalGrades(store),
    StudentProfileTemplates(store),
    FieldsConfiguration(store),
    PlannerElementSetConfiguration(store),
    ManageTemplates(store),
    RoutineAndMealTemplates(store),
    AssessmentToolSetup(store),
    ScoreCategories(store),
    Continuum(store),
    GradingPeriods(store),
    GradingPeriodsV3(store),
    GradingSetup(store),
    GradingSetupV2(store),
    AssessmentSettingsEvaluationCriteria(store),
    GpaAndCredits(store),
    WorkbookTemplates(store),
    ProjectProgressIndicators(store),
  ],
});
